/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnvService {
  /**
   * 获取nm版本信息
   * @returns any 成功
   * @throws ApiError
   */
  static getAbout() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/about'
    });
  }
  /**
   * 获取授权信息
   * @returns any 成功
   * @throws ApiError
   */
  static getLicenseGet() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/license/get'
    });
  }
  /**
   * 更新资源文件及配置
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postResourceUpdate(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/resource/update',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 获取资源文件及配置
   * @returns any 成功
   * @throws ApiError
   */
  static getResourceQuery() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/resource/query'
    });
  }
  /**
   * 重置资源文件及配置
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postResourceReset(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/resource/reset',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
}